import React from "react";
import { useLocation, useRoutes } from "react-router-dom";
import HomePage2 from "../pages/HomePage2";
import { AnimatePresence, motion } from "framer-motion";
import IntroPage from "../pages/IntroPage";
import LevelsPage from "../pages/LevelsPage";
import TermsPage from "../pages/TermsPage";
import AccountPage from "../pages/AccountPage";
import EasyModePage2 from "../pages/EasyModePage2";
import MediumModePage2 from "../pages/MediumModePage2";
import HardModePage2 from "../pages/HardModePage2";
import CategoriesPage from "../pages/CategoriesPage";

const Routing = () => {
  const routes = [
    {
      path: "/",
      element: <IntroPage />,
    },
    {
      path: "/home",
      element: <HomePage2 />,
    },
    {
      path: "/medium-mode",
      element: <MediumModePage2 />,
    },
    {
      path: "/easy-mode",
      element: <EasyModePage2 />,
    },
    {
      path: "/hard-mode",
      element: <HardModePage2 />,
    },
    {
      path: "/levels",
      element: <LevelsPage />,
    },
    {
      path: "/terms",
      element: <TermsPage />,
    },
    {
      path: "/account",
      element: <AccountPage />,
    },
    {
      path:"/category/:category",
      element:<CategoriesPage />
    }
  ];

  const element = useRoutes(routes);

  const location = useLocation();

  if (!element) return null;

  return (
    <AnimatePresence mode="wait" initial={false}>
      {element}
      <motion.div
        initial={{ scaleX: 1 }}
        key={location.pathname}
        animate={{ scaleX: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleX: 1, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originX: 1 }}
        className="privacy-screen"
      />
    </AnimatePresence>
  );
};

export default Routing;
